var React = require('react');

function Flickr (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M357.1,42.9c-31.5,0-57.1,25.6-57.1,57.1s25.6,57.1,57.1,57.1s57.1-25.6,57.1-57.1S388.7,42.9,357.1,42.9z M357.1,0\r\n\t\tL357.1,0c55.2,0,100,44.8,100,100c0,55.2-44.8,100-100,100s-100-44.8-100-100C257.1,44.8,301.9,0,357.1,0z M0,100\r\n\t\tc0,55.2,44.8,100,100,100s100-44.8,100-100C200,44.8,155.2,0,100,0S0,44.8,0,100z"})));
}

Flickr.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","width":"457.1px","height":"200px","viewBox":"0 0 457.1 200","style":{"enableBackground":"new 0 0 457.1 200"},"xmlSpace":"preserve"};

module.exports = Flickr;

Flickr.default = Flickr;
